import { Text, View } from '@react-pdf/renderer';
import { fontBold } from 'PDF/keys';
import React from 'react';

function Normal(props) {
  const {
    children,
    indent = false,
    negrita = false,
    debugC,
    debugT,
  } = props;
  const extraStyles = {};
  if (indent) {
    extraStyles.textIndent = '4pt';
  }
  return (
    <View style={{ height: 'auto', ...extraStyles }} debug={debugC}>
      <Text
        style={{
          fontSize: negrita ? '10pt' : '12pt',
          fontFamily: negrita ? fontBold : 'Times-Roman',
          textAlign: 'justify',
          textIndent: '25pt',
          maxWidth: '100%',
        }}
        debug={debugT}
      >
        {children}
      </Text>
    </View>
  );
}
export default Normal;
